import { render, staticRenderFns } from "./CaratSvg.vue?vue&type=template&id=6078688e"
import script from "./CaratSvg.vue?vue&type=script&lang=js"
export * from "./CaratSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports